<div class="app-main__inner">

  <!-- ══ RUNNER DASHBOARD ══════════════════════════════════════════════════ -->
  <ng-container *ngIf="isManager">
    <div class="rdr-wrap">

      <div class="rdr-loading" *ngIf="isLoadingRoutes">
        <div class="spinner-border spinner-border-sm text-primary"></div>
        <span>Loading routes…</span>
      </div>

      <div class="rdr-empty" *ngIf="!isLoadingRoutes && runnerRoutes.length === 0">
        <i class="pe-7s-way rdr-empty-icon"></i>
        <p>No routes are currently assigned to you.</p>
      </div>

      <div class="rdr-grid" *ngIf="!isLoadingRoutes && runnerRoutes.length > 0">
        <div class="rdr-card" *ngFor="let r of runnerRoutes">
          <div class="rdr-card-id">{{ r.routeid }}</div>
          <div class="rdr-card-desc">{{ r.description }}</div>
          <div class="rdr-card-footer">
            <span class="rdr-badge-day">
              <i class="pe-7s-date"></i> {{ ordinal(r.dataofrun) }} of each month
            </span>
            <span class="rdr-badge-members">
              <i class="pe-7s-users"></i> {{ r.memberCount }} member{{ r.memberCount !== 1 ? 's' : '' }}
            </span>
          </div>
        </div>
      </div>

    </div>
  </ng-container>

  <!-- ══ ADMIN DASHBOARD ═══════════════════════════════════════════════════ -->
  <div class="dash-wrap" *ngIf="!isManager">

    <!-- ── Greeting banner ───────────────────────────────────────────────── -->
    <div class="dash-greeting">
      <div class="dash-greeting__left">
        <div class="dash-greeting__salutation">
          <span class="dash-greeting__wave">👋</span>
          {{ greeting }}, <strong>{{ currentUser?.name || 'User' }}</strong>
        </div>
        <div class="dash-greeting__date">{{ todayLabel }}</div>
      </div>

      <div class="dash-greeting__chips">
        <!-- Loading skeletons -->
        <ng-container *ngIf="isLoadingSnapshot">
          <div class="dash-snap-chip dash-snap-chip--skeleton" *ngFor="let i of [1,2,3]"></div>
        </ng-container>

        <!-- Snapshot chips -->
        <ng-container *ngIf="!isLoadingSnapshot && todaySnapshot">
          <div class="dash-snap-chip dash-snap-chip--blue">
            <i class="pe-7s-upload dash-snap-chip__icon"></i>
            <div class="dash-snap-chip__body">
              <span class="dash-snap-chip__val">{{ todaySnapshot.issuedToday }}</span>
              <span class="dash-snap-chip__lbl">Issued Today</span>
            </div>
          </div>
          <div class="dash-snap-chip dash-snap-chip--green">
            <i class="pe-7s-download dash-snap-chip__icon"></i>
            <div class="dash-snap-chip__body">
              <span class="dash-snap-chip__val">{{ todaySnapshot.returnedToday }}</span>
              <span class="dash-snap-chip__lbl">Returned Today</span>
            </div>
          </div>
          <div class="dash-snap-chip dash-snap-chip--purple">
            <i class="pe-7s-add-user dash-snap-chip__icon"></i>
            <div class="dash-snap-chip__body">
              <span class="dash-snap-chip__val">{{ todaySnapshot.newMembersToday }}</span>
              <span class="dash-snap-chip__lbl">New Members</span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Member Overview — Grouped Bar Chart -->
    <div class="dash-section-label">
      <span>Member Overview</span>
      <button type="button" class="dash-refresh-btn" (click)="refresh()" title="Refresh">
        <i class="pe-7s-refresh"></i>
      </button>
    </div>

    <div *ngIf="isLoadingPie" class="dash-loading mb-3">
      <div class="spinner-border spinner-border-sm text-primary"></div>
    </div>

    <div *ngIf="!isLoadingPie" class="mbar-wrap mb-3">
      <div class="mbar-legend">
        <span class="mbar-leg-item" [class.mbar-leg-item--hidden]="hiddenBarSeries.has('H')" (click)="toggleBarSeries('H')">
          <span class="mbar-leg-dot mbar-leg-dot--h"></span>
          <span class="mbar-leg-text">Home Delivery</span>
        </span>
        <span class="mbar-leg-item" [class.mbar-leg-item--hidden]="hiddenBarSeries.has('L')" (click)="toggleBarSeries('L')">
          <span class="mbar-leg-dot mbar-leg-dot--l"></span>
          <span class="mbar-leg-text">At Center</span>
        </span>
      </div>
      <div class="mbar-groups">
        <div class="mbar-group" *ngFor="let g of BAR_GROUPS" [class]="'mbar-group mbar-group--' + g.colorClass">
          <div class="mbar-bars-row">
            <div class="mbar-col" *ngIf="!hiddenBarSeries.has('H')"
                 (click)="openStatDetail(g.statType, g.label + ' · Home Delivery', 'H')"
                 role="button" tabindex="0" [attr.aria-label]="g.label + ' Home Delivery: ' + getBarStat(g.key).H">
              <div class="mbar-num">{{ getBarStat(g.key).H }}</div>
              <div class="mbar-track">
                <div class="mbar-fill mbar-fill--h" [style.height.px]="getBarPx(g.key, 'H')"></div>
              </div>
            </div>
            <div class="mbar-col" *ngIf="!hiddenBarSeries.has('L')"
                 (click)="openStatDetail(g.statType, g.label + ' · At Center', 'A')"
                 role="button" tabindex="0" [attr.aria-label]="g.label + ' At Center: ' + getBarStat(g.key).L">
              <div class="mbar-num">{{ getBarStat(g.key).L }}</div>
              <div class="mbar-track">
                <div class="mbar-fill mbar-fill--l" [style.height.px]="getBarPx(g.key, 'L')"></div>
              </div>
            </div>
          </div>
          <div class="mbar-total">{{ getBarVisibleTotal(g.key) }}</div>
          <div class="mbar-label">{{ g.label }}</div>
        </div>
      </div>
    </div>

    <!-- Activity (last 30 days) — Pie Charts -->
    <div class="dash-section-label">Activity (last 30 days)</div>
    <div *ngIf="isLoadingPie" class="dash-loading mb-3">
      <div class="spinner-border spinner-border-sm text-primary"></div>
    </div>
    <div *ngIf="!isLoadingPie" class="pie-grid mb-3">
      <div class="pie-card" *ngFor="let chart of PIE_CHARTS"
           (click)="openStatDetail(chart.statType, chart.label)" role="button" tabindex="0">
        <div class="pie-card__title">{{ chart.label }}</div>
        <svg [attr.viewBox]="'0 0 80 80'" class="pie-svg">
          <circle cx="40" cy="40" [attr.r]="PIE_R" fill="none" stroke="#f1f5f9" stroke-width="10"/>
          <circle
            *ngFor="let seg of pieSegments(getPieStat(chart.key))"
            cx="40" cy="40" [attr.r]="PIE_R" fill="none"
            [attr.stroke]="seg.color"
            stroke-width="10"
            stroke-linecap="butt"
            [attr.stroke-dasharray]="seg.dash"
            [attr.stroke-dashoffset]="seg.offset"/>
          <text x="40" y="45" text-anchor="middle" class="pie-center-num">
            {{ getPieStat(chart.key).total }}
          </text>
        </svg>
        <div class="pie-legend">
          <span class="pie-leg-item">
            <span class="pie-dot" style="background:#f97316"></span>
            <span class="pie-leg-label">Door Del.</span>
            <span class="pie-leg-val">{{ getPieStat(chart.key).H }}</span>
          </span>
          <span class="pie-leg-item">
            <span class="pie-dot" style="background:#8b5cf6"></span>
            <span class="pie-leg-label">At Center</span>
            <span class="pie-leg-val">{{ getPieStat(chart.key).L }}</span>
          </span>
        </div>
      </div>
    </div>

    <!-- Route-wise Member Count — Stacked Bar Chart -->
    <div class="dash-section-label">Route-wise Member Count</div>
    <div *ngIf="!isLoadingRouteBar && routeBarStats.length > 0" class="sbar-totals-row mb-1">
      <span class="sbar-total-chip sbar-total-chip--member">Member <strong>{{ routeGrandTotals.member }}</strong></span>
      <span class="sbar-total-chip sbar-total-chip--due">Due <strong>{{ routeGrandTotals.due }}</strong></span>
      <span class="sbar-total-chip sbar-total-chip--hold">On Hold <strong>{{ routeGrandTotals.onHold }}</strong></span>
    </div>

    <div *ngIf="isLoadingRouteBar" class="dash-loading mb-3">
      <div class="spinner-border spinner-border-sm text-primary"></div>
    </div>

    <div *ngIf="!isLoadingRouteBar && routeBarStats.length > 0" class="sbar-wrap mb-3">
      <div class="sbar-top-row">
        <div class="sbar-hover-label">{{ hoveredRouteDesc }}</div>
        <div class="sbar-legend">
          <span class="sbar-leg-item" [class.sbar-leg-item--hidden]="hiddenRouteSeries.has('member')" (click)="toggleRouteSeries('member')">
            <span class="sbar-leg-dot sbar-leg-dot--member"></span><span class="sbar-leg-text">Member</span>
          </span>
          <span class="sbar-leg-item" [class.sbar-leg-item--hidden]="hiddenRouteSeries.has('due')" (click)="toggleRouteSeries('due')">
            <span class="sbar-leg-dot sbar-leg-dot--due"></span><span class="sbar-leg-text">Due</span>
          </span>
          <span class="sbar-leg-item" [class.sbar-leg-item--hidden]="hiddenRouteSeries.has('onHold')" (click)="toggleRouteSeries('onHold')">
            <span class="sbar-leg-dot sbar-leg-dot--hold"></span><span class="sbar-leg-text">On Hold</span>
          </span>
        </div>
      </div>
      <div class="sbar-chart">
        <div class="sbar-col" *ngFor="let r of routeBarStats"
             (mouseenter)="hoveredRouteDesc = r.description"
             (mouseleave)="hoveredRouteDesc = ''">
          <div class="sbar-stack">
            <div class="sbar-seg sbar-seg--hold"   [style.height.px]="getRouteSegPx(r.onHold, 'onHold')"
                 [class.sbar-seg--clickable]="r.onHold > 0 && !hiddenRouteSeries.has('onHold')"
                 (click)="r.onHold > 0 && !hiddenRouteSeries.has('onHold') && openRouteSegDetail(r, 'onHold')"></div>
            <div class="sbar-seg sbar-seg--due"    [style.height.px]="getRouteSegPx(r.due, 'due')"
                 [class.sbar-seg--clickable]="r.due > 0 && !hiddenRouteSeries.has('due')"
                 (click)="r.due > 0 && !hiddenRouteSeries.has('due') && openRouteSegDetail(r, 'due')"></div>
            <div class="sbar-seg sbar-seg--member" [style.height.px]="getRouteSegPx(r.member, 'member')"
                 [class.sbar-seg--clickable]="r.member > 0 && !hiddenRouteSeries.has('member')"
                 (click)="r.member > 0 && !hiddenRouteSeries.has('member') && openRouteSegDetail(r, 'member')"></div>
          </div>
          <div class="sbar-total">{{ getRouteVisibleTotal(r) }}</div>
          <div class="sbar-id">{{ r.routeId }}</div>
        </div>
      </div>
    </div>

    <!-- Library Overview + Network -->
    <div *ngIf="!isLoading">

      <div class="dash-lib-net-row mb-3">

        <div class="dash-lib-net-group">
          <div class="dash-section-label">Library Overview</div>
          <div class="row g-3 flex-nowrap">
            <div class="col">
              <div class="kpi-card kpi-card--indigo">
                <div class="kpi-card__icon"><i class="pe-7s-bookmarks"></i></div>
                <div class="kpi-card__body">
                  <div class="kpi-card__val">{{ stats?.totalTitles ?? 0 }}</div>
                  <div class="kpi-card__lbl">Total Titles</div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="kpi-card kpi-card--blue">
                <div class="kpi-card__icon"><i class="pe-7s-albums"></i></div>
                <div class="kpi-card__body">
                  <div class="kpi-card__val">{{ stats?.totalBooksInLibrary ?? 0 }}</div>
                  <div class="kpi-card__lbl">Copies in Library</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="dash-lib-net-divider"></div>

        <div class="dash-lib-net-group dash-lib-net-group--network">
          <div class="dash-section-label">Network</div>
          <div class="row g-3 flex-nowrap">
            <div class="col">
              <div class="kpi-card kpi-card--cyan">
                <div class="kpi-card__icon"><i class="pe-7s-home"></i></div>
                <div class="kpi-card__body">
                  <div class="kpi-card__val">{{ stats?.totalCenters ?? 0 }}</div>
                  <div class="kpi-card__lbl">Centers</div>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="kpi-card kpi-card--orange">
                <div class="kpi-card__icon"><i class="pe-7s-way"></i></div>
                <div class="kpi-card__body">
                  <div class="kpi-card__val">{{ stats?.totalRoutes ?? 0 }}</div>
                  <div class="kpi-card__lbl">Routes</div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="dash-loading" *ngIf="isLoading">
      <div class="spinner-border text-primary"></div>
    </div>

  </div><!-- end dash-wrap -->
</div>

<!-- ── Stat Detail Overlay ────────────────────────────────────────────────── -->
<div class="sd-overlay" *ngIf="showStatDetail" (click)="closeStatDetail()">
  <div class="sd-sheet" (click)="$event.stopPropagation()">

    <div class="sd-header">
      <span class="sd-title">{{ detailTitle }}</span>
      <button class="sd-close" (click)="closeStatDetail()" title="Close">✕</button>
    </div>

    <div class="sd-body">
      <app-member-list-panel
        [statFilter]="detailType"
        [statMemberType]="detailMemberType"
        [locationId]="detailLocationId"
        [showAddButton]="true"
        (addRequested)="onAddFromDashboard()"
        (editRequested)="onEditFromDashboard($event)">
      </app-member-list-panel>
    </div>

  </div>
</div>
